export default "__VITE_ASSET__Bfch2LNe__"